export class GetJournals {
  static readonly type = '[Journals] Get All Journals';
}